var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fullscreen-container"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/VU-LOGO.png"),"alt":"Logo"}})])
}]

export { render, staticRenderFns }